/* Choose Judge.me's native, paginated photo-first sort once; the app owns all data and interactions. */
if (!customElements.get('meridian-judge-reviews')) {
  customElements.define('meridian-judge-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.sortInitialized || new URLSearchParams(window.location.search).has('judgeme_review_uuid')) return;
      this.sortObserver = new MutationObserver(() => this.initializeSort());
      this.sortObserver.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
      this.initializeSort();
    }

    initializeSort() {
      if (this.sortInitialized) return;
      const select = this.querySelector('select.jdgm-sort-dropdown:not([disabled])');
      if (!select || !Array.from(select.options).some(option => option.value === 'pictures_first')) return;
      this.sortInitialized = true;
      this.sortObserver.disconnect();
      if (select.value !== 'pictures_first') {
        select.value = 'pictures_first';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    disconnectedCallback() {
      this.sortObserver?.disconnect();
    }
  });
}
